// Customizable Area Start
import { MouseEvent } from "react";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { getToken } from "../../../components/src/AuthService";
import { ContactsListViews, InviteFriendsStepType } from "./enums";

export const configJSON = require("./config");
export interface Review {
  rating:number
}
export interface Post {
days_ago:string;
hours_ago	:string;
minutes_ago:string
}
export interface Contact {
  id: string;
  type: string;
  attributes: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    country_code: string;
    phone_number: number;
    full_phone_number: string;
    waitlist_id: any | null;
    appointment_date: any | null;
    appointment_status: any | null;
    profile_pic_url: string | null;
    is_banned_user: boolean;
    is_opt_out_user: boolean;
    is_end_user:boolean;
    media_permission?: boolean;
    review?: Review;
    latest_post_details?:Post;
    message?:{error:string};
  };
}

export interface Account {
  id: string;
  type: string;
  attributes: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    country_code: string;
    phone_number: number;
    full_phone_number: string;
    profile_pic: {url : string} | null;
    is_end_user:boolean
  };
}

export interface NormalizedContact {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  phone: string;
  email: string;
  waitlist_id?: any;
  appointment_date?: any;
  appointment_status?: any;
  profile_pic_url?: string;
  is_banned_user: boolean;
  is_opt_out_user: boolean;
  is_end_user:boolean;
  media_permission: boolean;
  isContactInfoOpened: boolean;
  isActionMenuOpened: boolean;
  review?:Review;
  post?:Post;
  message?:{error:string};
}

export interface Props {
  classes?: any;
}

interface S {
  isVideoEnabled: boolean;
  contacts: Contact[];
  normalizedContacts: NormalizedContact[];
  filters: { name: string; checked: boolean }[];
  error: string;
  currentView: ContactsListViews;
  contactsFiles: any;
  acceptModal: boolean;
  contactToEdit?: {
    id: number;
    firstName: string;
    lastName: string;
    email?: string;
    fullPhoneNumber?: string;
  };
  activeFilter?: string;
  isLoading: boolean;
  openDialog: boolean;
  termsText:string;
  termsDescription:string;
  isMobileContactFilterOpen: boolean;
  selectedFilter: string;
  togglingPermissionContactId: number | null;
}

interface SS {
  navigation: any;
  stepType: InviteFriendsStepType;
}

export default class ContactsListContainerController extends BlockComponent<
  Props,
  S,
  SS
> {
  contactsApiCallId: string = "";
  banContactApiCallId: string = "";
  sendFileApiCallId: string = "";
  termsConditionsApiCallId:string = ""
  postingFeedPermissionApiCallId: string = "";
  toggleMediaPermissionApiCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    
    this.state = {
      contacts: [],
      isVideoEnabled: false, 
      normalizedContacts: [],
      filters: [
        { name: "All", checked: true },
        { name: "Banned Users", checked: false },
        { name: "Opt Outs", checked: false },
      ],
      error: "",
      currentView: ContactsListViews.LIST,
      contactsFiles: [],
      contactToEdit: undefined,
      acceptModal: false,
      activeFilter: "",
      isLoading: false,
      openDialog: false,
      termsText:"",
      termsDescription:"",
      isMobileContactFilterOpen: false,
      selectedFilter: "All Contacts",
      togglingPermissionContactId: null,
    };
  }

  allContacts = configJSON.allContacts;
  currentContacts = configJSON.currentContacts;
  viewProfile = configJSON.viewProfile;
  complianceInfo = configJSON.complianceInfo;
  editUser = configJSON.editUser;
  banUserText = configJSON.banUser;
  unbanUser = configJSON.unbanUser;
  approvePhotoAndVideo = configJSON.approvePhotoAndVideo;

  async componentDidMount() {
    this.fetchContacts();
    this.fetchPostingFeedPermission();
    localStorage.getItem("addContact") == ContactsListViews.ADD_CONTACT && this.checkFilter("");
    this.getTermsConditions();
  }

  componentDidUpdate(
    _prevProps: Readonly<Props>,
    prevState: Readonly<S>
  ): void {
    if (
      (this.getFilterName(prevState.filters) !==
        this.getFilterName(this.state.filters) &&
        this.state.filters.some((filter) => filter.checked)) ||
      (prevState.contactToEdit && !this.state.contactToEdit)
    ) {
      this.fetchContacts();
    }
  }

  getStyleByCondition = (condition: boolean, truthyStyle: string, falsyStyle: string) => {
    return condition ? truthyStyle : falsyStyle
  }

  setCurrentView = (view: ContactsListViews) => {
    this.setState({ currentView: view });
  };

  setContactsFiles = (files: any) => {
    this.setState({ contactsFiles: files, acceptModal: true });

  };

  getContactsByName = (name:string) => {
    return `Contact is ${name}`
  }

  deleteContactByName = (id:number) => {
    return id
  }

  handleClickOpen = () => {
    this.setState({openDialog:true})
   };
 
   handleClose = () => {
     this.setState({openDialog:false})
   };

  showContact = (contactId: number) => {
    
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), "ProfileView");
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    msg.addData(getName(MessageEnum.NavigationScreenNameMessage), contactId);
    this.send(msg);
  };

  toggleContactMenu = (contactId?: number) => {
    this.setState((prevState) => {
      return {
        normalizedContacts: prevState.normalizedContacts.map((contact) => {
          if (contact.id !== contactId) {
            return {
              ...contact,
              isActionMenuOpened: false,
            };
          } else {
            return {
              ...contact,
              isActionMenuOpened: !contact.isContactInfoOpened,
            };
          }
        }),
      };
    });
  };

  showUserInfo = (contactId?: number) => {
    this.setState((prevState) => {
      return {
        normalizedContacts: prevState.normalizedContacts.map((contact) => {
          if (contact.id !== contactId) {
            return {
              ...contact,
              isContactInfoOpened: false,
            };
          } else {
            return {
              ...contact,
              isContactInfoOpened: !contact.isContactInfoOpened,
            };
          }
        }),
      };
    });
  }

  normalizeContacts = (contacts: Contact[]): NormalizedContact[] => {
    return contacts.map((contact) => ({
      id: contact.attributes.id,
      firstName: contact.attributes.first_name,
      lastName: contact.attributes.last_name,
      fullName: `${contact.attributes.first_name} ${contact.attributes.last_name}`,
      phone: contact.attributes.full_phone_number,
      email: contact.attributes.email,
      waitlist_id: contact.attributes.waitlist_id || undefined,
      appointment_date: contact.attributes.appointment_date || undefined,
      appointment_status: contact.attributes.appointment_status || undefined,
      profile_pic_url: contact.attributes.profile_pic_url || undefined,
      is_banned_user: contact.attributes.is_banned_user,
      is_opt_out_user: contact.attributes.is_opt_out_user,
      media_permission: contact.attributes.media_permission ?? false,
      isContactInfoOpened: false,
      isActionMenuOpened: false,
      review:contact.attributes?.review,
      post:contact.attributes.latest_post_details,
      message:contact.attributes.message,
      is_end_user: contact.attributes.is_end_user,
    }));
  };

  normalizeAccount = (accounts: Account[]): NormalizedContact[] => {
    return accounts.map((account) => ({
      id: account.attributes.id,
      firstName: account.attributes.first_name,
      lastName: account.attributes.last_name,
      fullName: `${account.attributes.first_name} ${account.attributes.last_name}`,
      phone: account.attributes.full_phone_number,
      email: account.attributes.email,
      waitlist_id: undefined,
      appointment_date: undefined,
      appointment_status: undefined,
      profile_pic_url: account.attributes.profile_pic?.url,
      is_end_user:account.attributes.is_end_user,
      is_banned_user: true,
      is_opt_out_user: false,
      media_permission: false,
      isContactInfoOpened: false,
      isActionMenuOpened: false,
    }));
  };

  checkFilter = (filterName: string) => {
    if(filterName.includes("All")){
      this.setState({selectedFilter: "All Contacts"});
    } else if(filterName.length == 0){
      this.setState({selectedFilter: "Add Contacts"});
    } else{
      this.setState({selectedFilter: filterName});
    }
    this.setState({isMobileContactFilterOpen: false})
    this.setState((prevState) => {
      const updatedFilters = prevState.filters.map((filter) => {
        if (filter.name === filterName) {
          return {
            ...filter,
            checked: true,
          };
        } else {
          return {
            ...filter,
            checked: false,
          };
        }
      });

      const currentView = filterName
        ? ContactsListViews.LIST
        : ContactsListViews.ADD_CONTACT;
      localStorage.setItem("addContact","")

      return { filters: updatedFilters, currentView, activeFilter: filterName };
    });
  };

  getFilterName = (filters: { name: string; checked: boolean }[]): string => {
    return filters.find((filter) => filter.checked)?.name || "";
  };
  getContactsName = (name:string) => {
      return name
  }

  handleAddButton = (id:string) => {
    return id
  }

  openEditContactModal = (contactData: {
    id: number;
    firstName: string;
    lastName: string;
    email?: string;
    fullPhoneNumber?: string;
  }) => {
    this.setState({ contactToEdit: contactData });
  };

  closeEditContactModal = (e: any) => {
    e?.stopPropagation();
    this.setState({ contactToEdit: undefined });
  };

  fetchContacts(): boolean {
    const requestHeaders = {
      "Content-Type": configJSON.inviteFriendApiContentType,
      token: getToken(),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.contactsApiCallId = requestMessage.messageId;

    const currentFilterName = this.getFilterName(this.state.filters);
    const currentEndpoint =
      (currentFilterName === "All" && configJSON.contactsEndPoint) ||
      (currentFilterName === "Banned Users" &&
        configJSON.bannedContactsEndpoint) ||
      (currentFilterName === "Opt Outs" && configJSON.optOutContactEndpoint);

    this.setState({isLoading : true, normalizedContacts: []})

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      currentEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(requestHeaders)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  }

  getTermsConditions(): boolean {
    const requestHeaders = {
      "Content-Type": configJSON.inviteFriendApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.termsConditionsApiCallId = requestMessage.messageId;


    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getTermsConditionUrl
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(requestHeaders)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  }

  fetchPostingFeedPermission = (): boolean => {
    const requestHeaders = {
      "Content-Type": configJSON.inviteFriendApiContentType,
      token: getToken(),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.postingFeedPermissionApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_settings/settings/posting_feed"
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(requestHeaders)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  handleBanStatus(userId: number, status: boolean): boolean {
    const requestHeaders = {
      "Content-Type": configJSON.inviteFriendApiContentType,
      token: getToken(),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.banContactApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({
        contact: {
          is_banned_user: status,
        },
      })
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.contactsEndPoint}/${userId}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(requestHeaders)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPutMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  }

  sendContactsFile = () => {
    if (!this.state.contactsFiles.length) return;

    const formData = new FormData();

    formData.append("files", this.state.contactsFiles[0]);

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.sendFileApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: getToken(),
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "/account_block/contacts/import_contacts"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  };

  handleModalClose = () => {
    this.setState({acceptModal: false})
  }

 handleMessageData = (message:string) => {
  return message
 }

  getContacts = (name:string) => {
    return name
  }

  showLogs = (post:string,review:string,message:string) => {
    return `${post} posted ${review} ${message}`
  }

  
  handleGetActivityLogData = (posted:string,review:number) => {
    return `${posted} and ${review}`

  }



  async receive(_from: string, message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    if (apiRequestCallId === this.contactsApiCallId) {
      this.handleFetchContactsAPIResponse(message);
    }

    if (apiRequestCallId === this.banContactApiCallId) {
      this.handleBanStatusAPIResponse(message);
    }
    if(apiRequestCallId === this.termsConditionsApiCallId){
      this.handleGetTermsConditions(message)
    }

    if (apiRequestCallId === this.postingFeedPermissionApiCallId) {
      this.handlePostingFeedPermissionResponse(message);
    }

    if (apiRequestCallId === this.toggleMediaPermissionApiCallId) {
      this.handleToggleMediaPermissionResponse(message);
    }
  }

  showError = (error: string) => {
    this.setState({ error });
    setTimeout(() => this.setState({ error: "" }), 4000);
  };

  handleFetchContactsAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.setState({isLoading : false})

    if (responseJson?.error || responseJson?.errors?.length) {
      this.showError("Unable to get contacts");
      return;
    }

    if (responseJson?.data) {
      this.setState({
        contacts: responseJson.data,
        normalizedContacts: this.normalizeContacts(responseJson.data),
      });
    }

    if(responseJson?.contact){
      this.setState({
        contacts: [...responseJson.contact.data, ...responseJson.account.data],
        normalizedContacts: [...this.normalizeContacts(responseJson.contact.data), ...this.normalizeAccount(responseJson.account.data)],
      });
    }
  };

  handleBanStatusAPIResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (responseJson?.error || responseJson?.errors?.length) {
      this.showError("Something went wrong");
      return;
    }

    if (responseJson?.data) {
      this.fetchContacts();
    }
  };

  handleGetTermsConditions = (message:Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const description = responseJson.data[0].attributes.description;

   this.setState({termsDescription:description})
    console.log(description, "termsconditions");
  }

  handlePostingFeedPermissionResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const isEnabled = Boolean(responseJson?.data?.photo_video_enabled);
    this.setState({ isVideoEnabled: isEnabled });
  }

  toggleContactMediaPermission = (contactId: number, currentPermission: boolean) => {
    this.setState({ togglingPermissionContactId: contactId });

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.toggleMediaPermissionApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.contactMediaPermissionEndpoint}/${contactId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({ "Content-Type": configJSON.inviteFriendApiContentType, token: getToken() })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPutMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({ contact: { media_permission: !currentPermission } })
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleToggleMediaPermissionResponse = (message: Message) => {
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
  
    const errorResponse = message.getData(
      getName(MessageEnum.RestAPIResponceErrorMessage)
    );
  
    console.log(
      "toggle media permission response ===>",
      responseJson
    );
  
    if (errorResponse || responseJson?.errors?.length || responseJson?.error) {
      console.log(
        "toggle media permission error ===>",
        errorResponse || responseJson?.errors || responseJson?.error
      );

      this.setState({
        togglingPermissionContactId: null,
      });
      this.showError("Failed to update media permission. Please try again.");

      return;
    }
  
    if (responseJson?.data) {
      const updatedId = Number(
        responseJson.data.id ??
        responseJson.data.attributes?.id
      );
  
      const newPermission =
        responseJson.data.attributes?.media_permission ?? false;
  
      this.setState((prevState: any) => ({
        normalizedContacts: prevState.normalizedContacts.map((contact:any) =>
          contact.id === updatedId
            ? {
                ...contact,
                media_permission: newPermission,
              }
            : contact
        ),
  
        togglingPermissionContactId: null,
      }));
    } else {
      this.setState({
        togglingPermissionContactId: null,
      });
    }
  };
}
// Customizable Area End
